<div class="container-fluid">
	<div class="row">
		<div class="col-md-12">
			<iframe [src]="getURL()" frameborder="0" title="payment-frame" id="paymentFrame"></iframe>
		</div>
	</div>
</div>